import { computed, Directive, input } from '@angular/core';
import { hlm } from '@spartan-ng/helm/utils';
import type { ClassValue } from 'clsx';

@Directive({
  selector: '[hlmDialogHeader],hlm-dialog-header',
  host: {
    'data-slot': 'dialog-header',
    '[class]': '_computedClass()',
  },
})
export class HlmDialogHeader {
  public readonly userClass = input<ClassValue>('', { alias: 'class' });
  protected readonly _computedClass = computed(() =>
    hlm(
      'flex flex-col space-y-1.5 text-center sm:text-left p-md text-components-content-neutral-primary justify-center border-b border-stroke-neutral-light',
      this.userClass(),
    ),
  );
}
